function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40",
  viewBox: "0 0 40 40"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: "20",
  cy: "20",
  r: "19",
  fill: "#FFF",
  stroke: "#FABE28",
  strokeWidth: "2"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#353535",
  d: "M26.988 16.554v.43C26.988 21.616 23.298 27 16.59 27c-2.124 0-4.025-.538-5.59-1.615h.894c1.677 0 3.354-.539 4.584-1.508-1.565 0-2.907-1.077-3.466-2.477.224 0 .448.108.671.108.336 0 .671 0 1.006-.108-1.677-.323-2.906-1.723-2.906-3.446.447.215 1.006.43 1.677.43-1.007-.646-1.677-1.722-1.677-2.907 0-.646.223-1.292.447-1.83 1.789 2.153 4.472 3.553 7.602 3.66-.112-.215-.112-.538-.112-.753 0-1.939 1.678-3.554 3.69-3.554 1.006 0 2.012.43 2.683 1.077a6.149 6.149 0 002.348-.862c-.224.862-.894 1.508-1.565 1.939.782-.108 1.453-.323 2.124-.539-.67.862-1.342 1.508-2.012 1.939z"
}))));